export const PAGE_TITLE = "Online Monastery";

export const PAGE_TEXT =
  "At <b>OnlineMonastery.com</b>, Matthew J. Brownstein offers free training in The Anahat Meditation System, as detailed in his books The Sacred Geometry of Meditation and The Anahat Meditation System. This comprehensive training includes over 60 hours of video lessons, workbooks, and audio recordings.";

export const VIDEO_URL =
  "https://drive.google.com/file/d/1CZYT6UhOWiPqF2Kgg86RTu5RVYPoeWaE/preview";

export const LINK_BOX_TITLE = "OnlineMonastery.com";

export const LINK_BOX_LINK =
  "https://www.instituteofhypnotherapy.com/online-monastery/";

export const SECTION_CERTIFICATION = "Certification Opportunity:";

export const CERTIFICATION_HTML =
  "After one year of dedicated practice, students can apply to become a Certified <b>Anahat Meditation Teacher</b> by completing the course requirements and submitting a final essay.";

export const SECTION_DASHBOARD = "Dashboard Features:";

export const FOOTER_TEXT =
  "This free resource is designed to guide students on their path to deep meditation practice, self-mastery, and the opportunity to share these teachings as a certified instructor. Start your journey with The Anahat Meditation System today!";

export const SUCCESS_MESSAGE = "Data saved successfully";
